type TargetUrlParts = {
  pathname: string
  search?: string
  hash?: string
}

type EnsureEmbeddedPath = (window: Window, targetUrl: TargetUrlParts) => string

export const ensureEmbeddedPath: EnsureEmbeddedPath = (
  window,
  { hash, pathname, search }
) => {
  const url = new URL(
    `${window.location.origin}/${pathname.replace(/^\//, '')}`
  )
  if (typeof search === 'string') url.search = search
  if (typeof hash === 'string') url.hash = hash

  const queryParams = url.searchParams
  queryParams.set('embedded', 'true')
  url.search = queryParams.toString()

  const legacySlug = url.pathname.startsWith('/legacy') ? '' : '/legacy'

  return `${legacySlug}${url.pathname}${url.search}${url.hash}`
}
